<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on }">
      <span
        v-on="isLoading || disabled?false:on"
        class="pointer"
        :style="{
            opacity: (isLoading)?0.5:1
          }"
        :title="lang($store, `sap/listings.global.filter.order_statuses.${value}`)"
      >
        {{itemIcon(value)?itemIcon(value):'?'}}
      </span>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, key) in items"
        :key="key"
        @click="updateValue(key)"
      >
        <v-list-item-title :title="item.title">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import i18n from '@/i18n';
/* constants */
import { ORDER_STATUS_ICONS } from '@/constants/order_statuses_data';
import * as estimationStatuses from '../../constants/estimation_statuses';

export default {
  name: 'OrderStatus',
  props: {
    value: {
      type: String,
      default: estimationStatuses.ORDERED,
    },
    updateRequest: {
      type: Function,
      default: () => () => {
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const statuses = {};
    // eslint-disable-next-line no-unused-vars
    Object.entries(estimationStatuses)
      .forEach(([key, value]) => {
        statuses[value] = {
          title: this.itemTitle(value),
          text: this.itemIcon(value),
        };
      });

    return {
      orderStatuses: estimationStatuses,
      ORDER_STATUS_ICONS,
      items: statuses,
      isLoading: false,
    };
  },
  methods: {
    updateValue(value) {
      const oldValue = this.value;
      this.$emit('updated', value);
      this.isLoading = true;
      setTimeout(() => {
        this.updateRequest(value)
          .catch(error => {
            this.$emit('updated', oldValue);
            console.error(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }, 0);
    },
    itemTitle(value) {
      if (value === estimationStatuses.ORDERED) {
        return i18n.t('estimations.interested');
      }
      return this.lang(this.$store, `sap/listings.global.filter.order_statuses.${value}`);
    },
    itemIcon(value) {
      if (value === estimationStatuses.ORDERED) {
        return ORDER_STATUS_ICONS[`${value}_estimation`];
      }
      return ORDER_STATUS_ICONS[value];
    },
  },
};
</script>

<style scoped>

</style>
